import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ApplicationState }  from '../../store';
import * as AuthenticationState from '../../store/authentication';
const DocumentTitle = require('react-document-title');

// At runtime, Redux will merge together...
type LoginProps =
    AuthenticationState.AuthenticationState         // ... state we've requested from the Redux store
    & typeof AuthenticationState.actionCreators     // ... plus action creators we've requested
    & RouteComponentProps<{ }>;                     // ... plus incoming routing parameters

type State = {
    tenant: string;
    username: string;
    password: string;
}

class Login extends React.Component<LoginProps, State> {

    constructor(props: LoginProps) {
        super(props);

        this.state = {
            tenant: '',
            username: '',
            password: ''
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    public componentWillMount() {

        // TODO: Is token still valid?

        if (typeof window !== 'undefined') {
            if (window.location.hostname === "daycarium.com") {
                this.props.history.push("/");
            }
        }

        if (this.props.token) {
            this.props.history.push("/reports/attendancereport");
        }
    }
    public componentWillUpdate(nextProps: LoginProps) {
        if (nextProps.token) {
            this.props.history.push("/reports/attendancereport");
        }
    }

    public render() {
        return (
            <React.Fragment>
                <DocumentTitle title='Login' />
                {this.getTenantName() && <div className="text-center p-1">
                    <img className='img-fluid' style={{ maxHeight: '200px' }} src={`/images/logos/${this.getTenantName()}.png`} alt='' />
                </div>}
                <form className="form-signin" onSubmit={this.handleSubmit}>
                    {!this.getTenantName() && <div className="form-label-group">
                        <input
                            type="text"
                            id="inputTenant"
                            className="form-control"
                            placeholder="Company Name"
                            required
                            onChange={(event) => this.setState({ tenant: event.target.value })}
                        />
                    </div>}

                    <div className="form-label-group">
                        <input
                            type="text"
                            id="inputUsername"
                            className="form-control"
                            placeholder="Username"
                            autoComplete="username"
                            required
                            onChange={(event) => this.setState({ username: event.target.value })}
                        />
                    </div>

                    <div className="form-label-group">
                        <input
                            type="password"
                            id="inputPassword"
                            className="form-control"
                            placeholder="Password"
                            required
                            autoComplete="current-password"
                            onChange={(event) => this.setState({ password: event.target.value })}
                        />
                    </div>

                    <button type="submit" className="btn btn-lg btn-primary btn-block" onClick={this.handleSubmit}>Sign in</button>
                    <p className="mt-5 mb-3 text-muted text-center">&copy; {(new Date()).getFullYear()} Daycarium</p>
                </form>
            </React.Fragment>
        );
    }

    private getTenantName(): string {
        if (typeof window !== 'undefined') {
            const hostname = window.location.hostname.split('.');
            return (hostname.length > 2) ? hostname[0].toUpperCase() : '';
        }

        if (this.props.subdomain) {
            return this.props.subdomain;
        }
        return '';
    }

    private handleSubmit(event: React.FormEvent<HTMLFormElement>|React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        event.preventDefault();

        const tenant = this.getTenantName() || this.state.tenant;

        if (!tenant || !this.state.username || !this.state.password) {
            return;
        }

        this.props.getUserToken(tenant, this.state.username, this.state.password);
    }
}

export default withRouter(connect(
    (state: ApplicationState) => state.authentication, // Selects which state properties are merged into the component's props
    AuthenticationState.actionCreators                 // Selects which action creators are merged into the component's props
)(Login));
